import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { Download01, File05 } from '@kula-ai/icons-core';
import { downloadAttachment } from '../../../api/messages';
import type { MessageAttachment } from '../../../types/transcript';

export const AttachmentChip = ({
  sessionId,
  attachment,
}: {
  sessionId: string;
  attachment: MessageAttachment;
}) => {
  const pending = attachment.pending === true;
  const onClick = () => {
    if (pending) return;
    void downloadAttachment(sessionId, attachment);
  };
  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      disabled={pending}
      align="center"
      gap="8px"
      px="10px"
      py="6px"
      borderRadius="10px"
      bg="base-white"
      border="1px solid"
      borderColor="border-color"
      maxW="100%"
      cursor={pending ? 'default' : 'pointer'}
      _hover={pending ? undefined : { bg: 'secondary-50' }}
      _disabled={{ opacity: 1 }}
      title={
        pending
          ? `${attachment.filename} is attached`
          : `Download ${attachment.filename}`
      }
    >
      <Box as="span" flexShrink={0} color="secondary-500" aria-hidden>
        <File05 size={16} color="currentColor" />
      </Box>
      <Text
        variant="span"
        className="text-secondary-700 text-[14px]"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {attachment.filename}
      </Text>
      {/* Optimistic turns render immediately with local metadata. Hydration
          swaps the chip to the server-owned, downloadable "Parsed" state. */}
      <Box
        as="span"
        flexShrink={0}
        px="8px"
        py="2px"
        borderRadius="6px"
        bg="pastel-2-light"
        color="pastel-2-dark"
        fontSize="12px"
        fontWeight="600"
      >
        {pending ? 'Attached' : 'Parsed'}
      </Box>
      {!pending && (
        <Box as="span" flexShrink={0} color="secondary-500" aria-hidden>
          <Download01 size={14} color="currentColor" />
        </Box>
      )}
    </Flex>
  );
};
